module.exports = __webpack_public_path__ + "img/1_007.6c49937d.jpg";